<template>
  <div>
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      id="modalCreate"
      title="NOVO REGISTRO"
    >
      <CreateIMC v-on:success="paginate" :resident_id="resident_id" />
    </b-modal>

    <div class="row">
      <div
        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pr-0 d-flex align-items-center"
      >
        <h1 class="title-pages">IMC <small>Peso / Altura</small></h1>
      </div>
      <div
        class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pl-0 text-right pl-0"
      >
        <v-btn @click="$bvModal.show('modalCreate')" class="btn-add m-1"
          ><i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR</v-btn
        >
      </div>
    </div>

    <b-overlay :show="loading" opacity="0.99">
      <div class="v-clean p-5 text-center" v-show="imcs.length == 0">
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>

      <v-data-table
        v-show="imcs.length > 0"
        :headers="headers"
        :items="imcs"
        :search="search"
        :footer-props="{
          'items-per-page-options': [50, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
      >
        <template v-slot:[`item.user`]="{ item }">
          {{ item.user_name }}
        </template>

        <template v-slot:[`item.imc`]="{ item }">
          {{ handleTextImc(item.imc).imc }}
          ({{ handleTextImc(item.imc).classificacao }})
        </template>

        <template v-slot:[`item.created_at`]="{ item }">
          {{ formatDate(item.created_at) }}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <confirmation-dialog
            x_small
            message-title="EXCLUIR?"
            message-body="Deseja realmente excluir?"
            open-class="btn-modern btn-modern-delete m-1"
            open-left-icon="fa-trash"
            open-text="EXCLUIR"
            @yes="deleteIMC(item.id)"
          />
        </template>
      </v-data-table>
    </b-overlay>
  </div>
</template>

<script>
import api from "../../services/api";

import { formatDate } from "../../lib/format";

import CreateIMC from "./Create";

import ConfirmationDialog from "../Components/ConfirmationDialog";

import moment from "moment";

export default {
  name: "IMC",

  components: {
    CreateIMC,
    ConfirmationDialog,
  },

  props: {
    resident_id: [String, Number],
  },

  data() {
    return {
      search: "",

      start_date: moment().subtract(365, "days").format("YYYY-MM-DD"),

      end_date: moment().format("YYYY-MM-DD"),

      headers: [
        { text: "CRIADO POR", value: "user_name", sortable: false },
        { text: "PESO", value: "weight", sortable: false },
        { text: "ALTURA", value: "height", sortable: false },
        { text: "IMC", value: "imc", sortable: false },
        { text: "DATA CADASTRO", value: "created_at", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],

      imcs: [],

      imc: {},

      errors: [],

      loading: false,
    };
  },

  async created() {
    this.paginate();
  },

  methods: {
    formatDate,

    moment,

    handleTextImc(imc) {
      try {
        if (imc) {
          let text = JSON.parse(imc);
          return text;
        }

        return {
          imc: 0,
          classificacao: "Não identificado",
          cor: "white",
          alturaUsada: 0,
        };
      } catch (error) {
        return {
          imc: 0,
          classificacao: "Não identificado",
          cor: "white",
          alturaUsada: 0,
        };
      }
    },

    async paginate() {
      try {
        this.$bvModal.hide(`imc-${this.imc.id}`);

        this.loading = true;

        let { resident_id } = this;

        let params = {
          resident_id,
        };

        let response = await api.get("/rest-home/imcs", {
          params,
        });

        let { error, errors, imcs } = response.data;

        if (!error) {
          this.imcs = imcs;
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteIMC(id) {
      try {
        this.loadingDelete = true;

        let params = { id };

        let response = await api.patch("/rest-home/imc", params);

        let { error, errors } = response.data;

        if (!error) {
          this.$bvModal.hide(`imc-${id}`);
          this.paginate();
        } else {
          this.errors = errors;
        }

        this.loadingDelete = false;
      } catch (error) {
        console.log(error);
      }
    },

    clickRowTable({ id }) {
      this.errors = [];
      this.$bvModal.show(`imc-${id}`);
    },
  },
};
</script>